<img class="lazyload" src="{{data ? data : '../../../assets/images/avatar.png'}}" alt="image" [class.avatar]="small" [class.big-avatar]="!small" style="height: 100%;width: auto;">
